import React from "react";
import profile from "../../images/profile.png";
import { Typewriter } from "react-simple-typewriter";
import ScrollToTop from "react-scroll-up";
import { FaHackerrank, FaLinkedinIn, FaGithub } from "react-icons/fa";
import { SiLeetcode } from "react-icons/si";
import { Link } from 'react-scroll';

function Home() {
  return (
    <div id='home'>
      <div
        style={{
          background: "linear-gradient(135deg, #061d34 0%, #091c29 55%, #0d2137 100%)",
        }}
        className="h-[calc(100vh-4rem)] flex items-center relative overflow-hidden"
      >
        {/* Subtle dot grid background */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage: "radial-gradient(circle, rgba(255,255,255,0.045) 1px, transparent 1px)",
            backgroundSize: "28px 28px",
            pointerEvents: "none",
          }}
        />

        {/* Decorative radial glow behind image */}
        <div
          style={{
            position: "absolute",
            right: "20%",
            top: "50%",
            transform: "translate(50%, -50%)",
            width: "520px",
            height: "520px",
            borderRadius: "50%",
            background: "radial-gradient(circle, rgba(99,102,241,0.13) 0%, transparent 70%)",
            pointerEvents: "none",
          }}
        />

        <div className="w-11/12 max-w-7xl mx-auto flex flex-col md:flex-row-reverse items-center justify-center gap-16 py-10">

          {/* Profile Image */}
          <div
            className="flex justify-center md:flex-shrink-0"
            data-aos="zoom-in"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
          >
            <img
              className="max-h-96 md:max-h-[500px] w-auto object-contain"
              style={{ filter: "drop-shadow(0 0 32px rgba(99,102,241,0.25))" }}
              alt="profile"
              src={profile}
            />
          </div>

          {/* Text Content */}
          <div
            className="text-white text-center md:text-left flex-1"
            data-aos="fade-up"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
          >
            <p className="text-indigo-400 font-mono text-sm tracking-widest uppercase mb-4">
              Welcome to my portfolio
            </p>
            <h2 className="text-6xl md:text-8xl font-bold mb-4">Hi!</h2>
            <h1 className="text-3xl md:text-5xl font-mono mb-3">
              I'm <span className="font-bold text-cyan-400">Afid Md Azwad</span>
            </h1>
            <h4 className="text-xl md:text-3xl text-gray-400 font-mono mb-8">
              I am{" "}
              <span className="font-semibold text-yellow-300">
                <Typewriter
                  words={[
                    "a Software Engineer",
                    "a Python Backend Engineer",
                    "a Django Developer",
                    "an Odoo ERP Developer",
                  ]}
                  loop={0}
                  typeSpeed={70}
                  deleteSpeed={50}
                  delaySpeed={1000}
                />
              </span>
            </h4>

            {/* CTA Button */}
            <div className="mb-6 flex justify-center md:justify-start">
              <Link activeClass="active" to="project" spy={true} smooth={true}>
                <button className="bg-indigo-600 hover:bg-indigo-700 text-white border border-indigo-500 px-7 py-2.5 rounded-full font-semibold transition-all duration-300">
                  View My Work
                </button>
              </Link>
            </div>

            {/* Social Links */}
            <div className="flex gap-4 justify-center md:justify-start">
              {/* LinkedIn — brand blue */}
              <a
                href="https://www.linkedin.com/in/afid-md-azwad-05537a196/"
                target="_blank"
                rel="noreferrer"
                className="w-11 h-11 flex items-center justify-center rounded-full border border-gray-300 bg-white/10 text-white hover:text-[#0077B5] hover:border-[#0077B5] hover:bg-[#0077B5]/20 transition-all duration-300"
              >
                <FaLinkedinIn size={18} />
              </a>
              {/* GitHub — purple */}
              <a
                href="https://github.com/AfidAzwad"
                target="_blank"
                rel="noreferrer"
                className="w-11 h-11 flex items-center justify-center rounded-full border border-gray-300 bg-white/10 text-white hover:text-[#6e40c9] hover:border-[#6e40c9] hover:bg-[#6e40c9]/20 transition-all duration-300"
              >
                <FaGithub size={18} />
              </a>
              {/* LeetCode — brand orange */}
              <a
                href="https://leetcode.com/u/afidazwad/"
                target="_blank"
                rel="noreferrer"
                className="w-11 h-11 flex items-center justify-center rounded-full border border-gray-300 bg-white/10 text-white hover:text-[#FFA116] hover:border-[#FFA116] hover:bg-[#FFA116]/20 transition-all duration-300"
              >
                <SiLeetcode size={18} />
              </a>
              {/* HackerRank — brand green */}
              <a
                href="https://www.hackerrank.com/mdazwad22"
                target="_blank"
                rel="noreferrer"
                className="w-11 h-11 flex items-center justify-center rounded-full border border-gray-300 bg-white/10 text-white hover:text-[#00EA64] hover:border-[#00EA64] hover:bg-[#00EA64]/20 transition-all duration-300"
              >
                <FaHackerrank size={18} />
              </a>
            </div>
          </div>

        </div>
      </div>

      <div>
        <ScrollToTop showUnder={160} smooth={true}>
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            className="w-4 h-4"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <path
              fill="currentColor"
              d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
            ></path>
          </svg>
        </ScrollToTop>
      </div>

    </div>
  );
}

export default Home;
